/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import {createRoot} from 'react-dom/client';
import StandardApp from 'qwc2/components/StandardApp';
import appConfig from './appConfig';
import '../icons/build/qwc2-icons.css';

// WOB: Add login redirect (see QWC2 Solothurn "sogis-qwc2-app")
// const container = document.getElementById('container');
// const root = createRoot(container);
// root.render(<StandardApp appConfig={appConfig}/>);

import ConfigUtils from "qwc2/utils/ConfigUtils";
import { UrlParams } from "qwc2/utils/PermaLinkUtils";

// Sourcepole: Addition for external WMS ("extwms")
import axios from "axios";
import url from "url";

// WOB: No action, if redirected from auth service
if (UrlParams.getParam("config:autologin") !== undefined) {
    UrlParams.updateParams({ "config:autologin": undefined });
    renderApp();
// WOB: Automatic login
} else {
    ConfigUtils.loadConfiguration().then((config) => {
        const requireLogin = config?.wob_requireLogin;
        const username = config?.username;
        const authServiceUrl = config?.authServiceUrl;

        // WOB: If config contains wob_requireLogin=true, redirect to auth service login
        if (requireLogin && !username && authServiceUrl) {
            const urlObj = url.parse(window.location.href);
            urlObj.query = { ...UrlParams.getParams() };
            urlObj.query["config:autologin"] = 1;
            urlObj.search = undefined;
            window.location.href = authServiceUrl + "login?url=" + encodeURIComponent(url.format(urlObj));
        } else {
            renderApp();
        }
    });
}

function renderApp() {
    // Sourcepole: Addition for external WMS ("extwms")
    axios.interceptors.request.use(
        (config) => {
            if (config.method === "get") {
                const parts = url.parse(config.url, true);
                if (parts.host !== "geoviewer.stadt.wolfsburg.de" && (parts.query.service || parts.query.SERVICE || "").toLowerCase() === "wms") {
                    config.url = "/extwms?url=" + encodeURIComponent(config.url);
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const container = document.getElementById('container');
    const root = createRoot(container);
    root.render(<StandardApp appConfig={appConfig}/>);
}
